export const DEMO_DOC_LINKS = [
  {
    title: 'Round 1 - Taiwan',
    url: 'https://docs.google.com/forms/d/e/1FAIpQLScUVR8lwj5tKjs8KNX68fpotMsZ4Y5vcZQrniuIdAhByKzAjQ/viewform',
  },
  {
    title: 'Round 1 - United States',
    url: 'https://docs.google.com/forms/d/e/1FAIpQLSegSD1dNn_-yu4bqY5y0I8NV1JJ7JaXTTDfL7o8-BWkIYB2VQ/viewform',
  },
  {
    title: 'Round 2 - Taiwan',
    url: 'https://docs.google.com/forms/d/e/1FAIpQLSd670h_hh86lmVutck7vW10nHqztpRSGhFR82qbdOAMjGEYaA/viewform',
  },
  {
    title: 'Round 2 - United States',
    url: 'https://docs.google.com/forms/d/e/1FAIpQLSePKg4t8O0m0U0tqgu395MV6rTJH2K-uNvA3vfJ7c8L2VeGCQ/viewform',
  },
];
